import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { SearchBarProps, Type } from './SearchBar.types';

const SearchBar: React.FC<SearchBarProps> = ({
  handleChange,
  placeholder,
  type = Type.TEXT,
  value,
  register,
  searchBarStyle,
  maxLength,
  className,
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      {type === Type.TEXT && (
        <InputText
          maxLength={maxLength}
          unstyled
          onChange={handleChange}
          value={value}
          {...register}
          placeholder={placeholder}
          className={`bg-[#2D2D2D] w-full pr-10 pl-4 py-3 rounded-[8px] text-white placeholder:text-white placeholder:text-[12px] ${searchBarStyle}`}
        />
      )}
      {type === Type.TEL && (
        <InputMask
          unstyled
          unmask
          value={value}
          onChange={handleChange}
          mask="999999999"
          className="bg-[#2D2D2D] w-full pr-10 pl-4 py-3 rounded-[8px] text-white placeholder:text-white placeholder:text-[12px]"
          placeholder={placeholder}
        />
      )}
      <span className="absolute right-3 top-[55%] -translate-y-1/2 text-[#D0D5DD]">
        <i className="pi pi-search"></i>
      </span>
    </div>
  );
};

export default SearchBar;
